import { createFileRoute, redirect } from '@tanstack/react-router';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { preLoadDefaultProject } from '@/lib/queries/project';
import { slackAuth } from '@/lib/queries/slackAuth';
import { supabaseClient } from '@/lib/supabase';

export const Route = createFileRoute('/authorize/slack/$userId/$teamId/$appId')(
  {
    loader: async ({ context, params: { userId, teamId, appId } }) => {
      const {
        data: { session },
      } = await supabaseClient.auth.getSession();

      if (!session) {
        throw redirect({
          to: '/sign-in',
          search: { source: 'slack', userId },
        });
      }
      try {
        const defaultProject = await preLoadDefaultProject({ context });
        await slackAuth(defaultProject.id, userId);

        // Build a deep link URL to open your Slack app's Home tab on desktop.
        // Slack deep link for app home: slack://app?team=TEAM_ID&id=APP_ID
        const slackDeepLinkUrl = `slack://app?team=${teamId}&id=${appId}`;

        // Return the deep link URL so the component can perform a client-side redirect.
        return { slackDeepLinkUrl };
      } catch (e) {
        console.error(e);
        context.toast({
          title: 'configuration.mcpJwt.button.error',
          variant: 'destructive',
        });
        throw redirect({ to: '/' });
      }
    },
    component: LinkedSlackIntegrationPage,
  },
);

function LinkedSlackIntegrationPage() {
  const { slackDeepLinkUrl } = Route.useLoaderData();

  useEffect(() => {
    // Perform client-side redirection to the Slack deep link.
    window.location.href = slackDeepLinkUrl;
  }, [slackDeepLinkUrl]);

  return (
    <main className="flex items-center justify-center min-h-screen bg-inherit">
      <div className="w-full max-w-md p-6 bg-inherit shadow-lg rounded-md">
        <h1 className="text-xl font-semibold text-inherit mb-4">
          <FormattedMessage id="slackIntegration.successMessage" />
        </h1>
        <p className="text-sm text-inherit mb-6">
          <FormattedMessage id="slackIntegration.appOpen" />
          <a href={slackDeepLinkUrl}>
            <FormattedMessage id="slackIntegration.here" />
          </a>
          .
        </p>
      </div>
    </main>
  );
}
